import React from "react";
import aboutUsData from "../data/aboutUsData";

const AboutUsContentWrapper = () => {
  return (
    <div className="about-us-content-wrapper">
      <div>
        <h1 className="mb-2 about-head">About Us</h1>
        {aboutUsData.length > 0 &&
          aboutUsData.map((val, i) => <p key={i}>{val}</p>)}
      </div>
    </div>
  );
};

export default AboutUsContentWrapper;
